export default ({ route, app }) => {
  // Take the last value (latest route child)
  const crumb = route.meta.reduce((crumb, meta) => meta.crumb || crumb, null)
  app.store.commit('crumb/setCrumb', crumb)
}
